'use client';

import Loading from '@/components/ui/loading';
import React, { useMemo, useState } from 'react';
import Turnstile from 'react-turnstile';
import { Env } from '@/libs/env';
import { Dialog, DialogContent } from '@/components/ui/dialog';
import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { useTranslations } from 'next-intl';
import { useNormalizedLocale } from '@/hooks/use-normalized-locale';

const ModalCloudflare = NiceModal.create(() => {
  const locale = useNormalizedLocale();
  const t = useTranslations('auth');
  const modal = useModal();
  const siteKey = Env.NEXT_PUBLIC_CLOUND_FLARE_KEY;
  const [loading, setLoading] = useState(true);

  const onLoad = () => {
    setLoading(false);
  };

  const handleVerify = (token: string) => {
    modal.resolve(token as string);
    modal.hide();
  };

  const host = useMemo(() => {
    return window.location.host;
  }, []);

  return (
    <Dialog open={modal.visible} onOpenChange={(open) => !open && modal.hide()}>
      <DialogContent className="!p-0">
        <div className='left-0 top-0 z-50 bg-white min-h-[100vh]'>
          <div className='flex flex-col items-center'>
            {/* 居中展示turnstile组件 */}
            <div className='flex justify-center h-full'>
              <div className="flex-1 flex flex-col mt-20 pl-5">
                {/* Header with Logo */}
                <div className="flex items-center">
                  <div className="flex items-center">
                    <span className="text-black font-medium text-lg">{host}</span>
                  </div>
                </div>
                {/* Main Instruction */}
                <div className="mt-4 mb-4">
                  <h1 className="text-black text-xl font-medium">
                    {t('cloudflare.text1')}
                  </h1>
                </div>

                {/* Turnstile Component */}
                <div>
                  {loading && (
                    <Loading className="w-10 h-10" />
                  )}

                  <Turnstile
                    language={locale}
                    sitekey={siteKey}
                    onVerify={handleVerify}
                    onLoad={onLoad}
                  />
                </div>

                {/* Security Message */}
                <div className="mt-6">
                  <p className="text-black text-sm">
                    {t('cloudflare.text2')}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
});

export default ModalCloudflare;